import { lazy } from 'react';

export default [
    {
        path: ['/hsbc'],
        component: lazy(() => import(/* webpackChunkName: 'HsbcRoot' */ './component')),
        routes: [],
    },
];
